import React from 'react'

const num = (v) => (v === null || v === undefined || v === '' ? '—' : String(v))

const collegeIdMatch = (selection, rowId) => Number(selection.collegeId) === Number(rowId)

export const student911CollegeColumnTitles = [
	'ID',
	'Class',
	'College',
	'State',
	'City',
	'Rank',
	'GPA',
	'Accept %',
	'0–10%',
	'1–11%',
	'26–50%',
	'51–75%',
	'76–100%',
	'SAT',
	'ACT',
	'Tuition',
	'UG Enroll',
	'Select'
]

/** Column menu: these are checked / visible on first load (inverse of former defaults). */
export const student911DefaultVisibleColumnTitles = [
	'College',
	'State',
	'Rank',
	'GPA',
	'Accept %',
	'0–10%',
	'1–11%',
	'26–50%',
	'51–75%',
	'76–100%',
	'SAT',
	'Select',
]

export const getStudent911CollegeColumns = (prevSelections, setSelections, studentId) => [
	{
		id: 'cl911-id',
		name: 'ID',
		selector: (row) => row.id,
		sortable: true,
		minWidth: '70px',
		maxWidth: '70px',
		grow: 0,
		wrap: true
	},
	{
		id: 'cl911-class',
		name: 'Class',
		selector: (row) => row.class || '',
		sortable: true,
		minWidth: '130px',
		grow: 2,
		cell: (row) => (
			<div className="text-truncate" style={{ minWidth: 0, width: '100%' }} title={row.class}>
				{row.class || '—'}
			</div>
		)
	},
	{
		id: 'cl911-college',
		name: 'College',
		selector: (row) => row.college_name || '',
		sortable: true,
		minWidth: '160px',
		grow: 2,
		cell: (row) => (
			<div className="text-truncate" style={{ minWidth: 0, width: '100%' }} title={row.college_name}>
				{row.college_name || '—'}
			</div>
		)
	},
	{
		id: 'cl911-state',
		name: 'State',
		selector: (row) => row.state || '',
		sortable: true,
		minWidth: '70px',
		grow: 0,
		maxWidth: '90px'
	},
	{
		id: 'cl911-city',
		name: 'City',
		selector: (row) => row.city || '',
		sortable: true,
		minWidth: '100px',
		grow: 2,
		cell: (row) => (
			<div className="text-truncate" style={{ minWidth: 0, width: '100%' }} title={row.city}>
				{row.city || '—'}
			</div>
		)
	},
	{
		id: 'cl911-rank',
		name: 'Rank',
		selector: (row) => row.ranking ?? '',
		sortable: true,
		minWidth: '80px',
		grow: 1
	},
	{
		id: 'cl911-gpa',
		name: 'GPA',
		selector: (row) => row.gpa ?? '',
		sortable: true,
		minWidth: '75px',
		grow: 1
	},
	{
		id: 'cl911-accept',
		name: 'Accept %',
		selector: (row) => row.acceptance ?? '',
		sortable: true,
		minWidth: '105px',
		grow: 1
	},
	{
		id: 'cl911-010',
		name: '0–10%',
		selector: (row) => row['0_10'] ?? '',
		sortable: true,
		minWidth: '70px',
		grow: 1
	},
	{
		id: 'cl911-111',
		name: '1–11%',
		selector: (row) => row['1_11'] ?? '',
		sortable: true,
		minWidth: '70px',
		grow: 1
	},
	{
		id: 'cl911-2650',
		name: '26–50%',
		selector: (row) => row['26_50'] ?? '',
		sortable: true,
		minWidth: '75px',
		grow: 1
	},
	{
		id: 'cl911-5175',
		name: '51–75%',
		selector: (row) => row['51_75'] ?? '',
		sortable: true,
		minWidth: '75px',
		grow: 1
	},
	{
		id: 'cl911-76100',
		name: '76–100%',
		selector: (row) => row['76_100'] ?? '',
		sortable: true,
		minWidth: '80px',
		grow: 1
	},
	{
		id: 'cl911-sat',
		name: 'SAT',
		selector: (row) => `${num(row.low_sat)}–${num(row.high_sat)}`,
		sortable: false,
		minWidth: '110px',
		grow: 1
	},
	{
		id: 'cl911-act',
		name: 'ACT',
		selector: (row) => `${num(row.low_act)}–${num(row.high_act)}`,
		sortable: false,
		minWidth: '100px',
		grow: 1
	},
	{
		id: 'cl911-tuition',
		name: 'Tuition',
		selector: (row) => row.tuition ?? '',
		sortable: true,
		minWidth: '90px',
		grow: 1
	},
	{
		id: 'cl911-ugenroll',
		name: 'UG Enroll',
		selector: (row) => row.undergraduate_enrollment ?? '',
		sortable: true,
		minWidth: '95px',
		grow: 1
	},
	{
		id: 'cl911-select',
		name: 'Select',
		cell: (row) => {
			const isSelected = prevSelections.some((p) => collegeIdMatch(p, row.id))
			return (
				<div className="form-check">
					<input
						className="checkbox_animated"
						type="checkbox"
						checked={isSelected}
						onChange={(e) => {
							if (e.target.checked) {
								setSelections((prev) => [...prev, { collegeId: row.id, studentId }])
							} else {
								setSelections((prev) => prev.filter((item) => !collegeIdMatch(item, row.id)))
							}
						}}
					/>
				</div>
			)
		},
		minWidth: '80px',
		maxWidth: '80px',
		grow: 0,
		ignoreRowClick: true,
		style: { backgroundColor: '#efeeff' }
	}
]
